import CardFastSunnah from './CardFastSunnah';

export default CardFastSunnah;
